<script setup>
import { dropdownTriggers } from '@/constants/dropdown';

const props = defineProps({
  opened: {
    type: Boolean,
    default: false,
  },

  position: {
    type: String,
    default: 'bottom-start',
  },
  triggerEvent: {
    type: String,
    default: dropdownTriggers.hover,
    validator(trigger) {
      return Object.values(dropdownTriggers).includes(trigger);
    },
  },
  referenceRef: {
    type: Object,
    default: undefined,
  },

  hoverHideDelay: {
    type: Number,
    default: 300,
  },
  gap: {
    type: Number,
    default: 10,
  },

  stretchContent: {
    type: Boolean,
    default: false,
  },
  useVIf: {
    type: Boolean,
    default: false,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  closeOnTriggerDoubleClick: {
    type: Boolean,
    default: true,
  },
});

const calculatedGap = useResizedPx(props.gap);

const dropdownRef = ref(null);
const visible = computed(() => dropdownRef.value?.visible);
function open() {
  dropdownRef.value?.open();
}
function close() {
  dropdownRef.value?.close();
}

defineExpose({ open, close, visible });
</script>

<template>
  <CDropdown
    ref="dropdownRef"
    :opened="opened"
    :position="position"
    :trigger-event="triggerEvent"
    :reference-ref="referenceRef"
    :hover-hide-delay="hoverHideDelay"
    :gap="calculatedGap"
    :stretch-content="stretchContent"
    :use-v-if="useVIf"
    :disabled="disabled"
    :close-on-trigger-double-click="closeOnTriggerDoubleClick"
  >
    <template #trigger="{ visible: dropdownVisible }">
      <slot name="trigger" :visible="dropdownVisible" />
    </template>

    <template #content="{ close: closeDropdown }">
      <slot name="content" :close="closeDropdown" />
    </template>
  </CDropdown>
</template>
